//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faExternalLinkAlt as fasExternalLinkAlt } from '@fortawesome/pro-solid-svg-icons';
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons';
import { humanFileSize } from '@/helpers/file.js';

export default {
  code: 'detail-prop',
  props: {
    code: {
      type: String,
      required: true,
    },
    element: {
      type: Object,
      required: true,
    },
    masterVariant: {
      type: Object,
      required: false,
    },
    schema: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fasExternalLinkAlt,
      faExternalLink,
    };
  },
  computed: {
    label() {
      return this.schema.label;
    },
    isBoolean() {
      return this.schema.type === 'boolean';
    },
    isFileSize() {
      return this.schema.type === 'fileSize';
    },
    isArray() {
      return !!this.schema.array;
    },
    isNumber() {
      return this.schema.type === 'number';
    },
    format() {
      return _.get(this.masterVariant, 'format', '');
    },
    value() {
      if (['license', 'youtubeContentId', 'modelRelease', 'propertyRelease', 'allowMusicalWorks'].includes(this.code)) {
        return _.get(this.element.usageRights, this.code);
      }

      if (['textPlaceholders', 'videoPlaceholders', 'logoPlaceholders'].includes(this.code)) {
        const placeholderType = this.code.replace('Placeholders', '');
        const value = _.get(this.element.mediaTypeDetails, `placeholders.${placeholderType}`);
        return value && value > 0 ? value : null;
      }

      if (['hasMusic', 'hasSfx', 'hasVideo'].includes(this.code)) {
        const key = this.code.replace('has', '').toLowerCase();
        return _.get(this.element, `mediaTypeDetails.mediaIncluded[${key}]`) || false;
      }

      if (['fps', 'size'].includes(this.code)) {
        return _.get(this.masterVariant, this.code) || false;
      }

      if (this.code === 'fileTypeIncluded') {
        return this.format ? `.${this.format}` : null;
      }

      if (this.isFileSize) {
        return humanFileSize(_.get(this.masterVariant, 'file.size', 0), 1, false);
      }

      if (this.code === 'placeholders') {
        return _.get(this.element.mediaTypeDetails, 'placeholders.text', null);
      }

      if (this.code === 'aiGenerator') {
        return this.aiGeneratorName;
      }

      if (this.code === 'aiModel') {
        return this.aiModelName;
      }

      const value = _.get(this.element.mediaTypeDetails, this.code, null);

      // if (Array.isArray(value) && value.length === 0) {
      //   return null;
      // }
      //
      // if (value === 0) {
      //   return null;
      // }

      return value === '' || value === 0 || (Array.isArray(value) && value.length === 0) ? null : value;
      // return value !== '' ? value : null;
    },
    aiGeneratorName() {
      const generator = this.element.categories.find(({ type }) => type === 'generator');
      return _.get(generator, 'name');
    },
    aiModelName() {
      return _.get(this.element, 'mediaTypeDetails.aiModel');
    },
  },
  methods: {
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    },
    renderReleaseTooltipText(code) {
      switch (code) {
        case 'modelRelease':
          return this.$t('product_page.signed_{item}_filed_text', { item: this.$t('product.model_release') });
        case 'propertyRelease':
          return this.$t('product_page.signed_{item}_filed_text', { item: this.$t('product.property_release') });
        default:
          return '';
      }
    },
  },
};
